<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M25.466 4H13.733a1.2 1.2 0 000 2.4h4.335l-6.4 19.2H6.533a1.2 1.2 0 100 2.4h11.734a1.2 1.2 0 000-2.4h-4.07l6.4-19.2h4.87a1.2 1.2 0 000-2.4z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'editorTextItalicOutline'
}
</script>
